import React from "react";
import PhoneInput from "react-phone-input-2";
import 'react-phone-input-2/lib/plain.css';

export default function PhoneField({ value, onChange }) {

	return <div className="phoneField flexy">

		<div style={{ flex: 2 }}>
			<PhoneInput
				enableLongNumbers={true}
				country={'gb'}
				value={value || ""}
				onChange={tel => onChange(tel.replace(/^\+44 0/, "+44 "))}
			/>
		</div>

	</div>
}